module.exports = __webpack_public_path__ + "static/media/Acapulco.e3f13f39.jpg";